import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import * as moment from 'moment';

/**
 * Formata uma string de data para o formato 'YYYY-MM-DD'.
 * @param dateString A string de data a ser formatada.
 * @returns A data formatada ou uma string vazia se a entrada for inválida.
 */
function formatDate(dateString: string | null | undefined): string {
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

@Injectable({
  providedIn: 'root'
})
export class AfericaoAmpliacaoService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getAfericaoAmpliacaos(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    filterText: string,
    filterData: any,
    statusFilter: any,
    customFilter:any,
    filtersRange:any
  ) {
    const parseCurrency = (value: string) => {
      if (!value) return 0;
      // remove pontos de milhar e troca vírgula por ponto
      return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    };
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('codigoOuDescricaoServico', filterText  || '')
      .set('nomeOrigemObra', filterData?.value?.nomeOrigemObra || '')
      .set('nomeTipoObra', filterData?.value?.nomeTipoObra || '')
      .set('sentido', filterData?.value?.sentido || '')
      .set('segmentoHomogeneo', filterData?.value?.segmentoHomogeneo || '')
      .set('kmInicialInicio', filterData?.value?.kmInicialInicio || '')
      .set('kmInicialFim', filterData?.value?.kmInicialFim || '')
      .set('kmFinalInicio', filterData?.value?.kmFinalInicio || '')
      .set('kmFinalFim', filterData?.value?.kmFinalFim || '')
      .set('kmCampoInicialInicio', filterData?.value?.kmCampoInicialInicio || '')
      .set('kmCampoInicialFim', filterData?.value?.kmCampoInicialFim || '')
      .set('kmCampoFinalInicio', filterData?.value?.kmCampoFinalInicio || '')
      .set('kmCampoFinalFim', filterData?.value?.kmCampoFinalFim || '')
      .set('naturezaPrazo', filterData?.value?.naturezaPrazo || '')
      .set('valorObraInicio', parseCurrency(filterData?.value?.valorObraInicio) || '')
      .set('valorObraFim', parseCurrency(filterData?.value?.valorObraFim) || '')
      .set('valorObraAtualizadoInicio', parseCurrency(filterData?.value?.valorObraAtualizadoInicio)  || '')
      .set('valorObraAtualizadoFim', parseCurrency(filterData?.value?.valorObraAtualizadoFim)  || '')
      .set('latitudeInicialInicio', parseFloat(filterData?.value?.latitudeInicialInicio)  || '')
      .set('latitudeInicialFim', parseFloat(filterData?.value?.latitudeInicialFim)  || '')
      .set('latitudeFinalInicio', parseFloat(filterData?.value?.latitudeFinalInicio)  || '')
      .set('latitudeFinalFim', parseFloat(filterData?.value?.latitudeFinalFim)  || '')
      .set('longitudeInicialInicio', parseFloat(filterData?.value?.longitudeInicialInicio)  || '')
      .set('longitudeInicialFim', parseFloat(filterData?.value?.longitudeInicialFim)  || '')
      .set('longitudeFinalInicio', parseFloat(filterData?.value?.longitudeFinalInicio)  || '')
      .set('longitudeFinalFim', parseFloat(filterData?.value?.longitudeFinalFim) || '');
    if (filterData?.value?.rodovia) {
      params = params.set('rodovia', filterData?.value?.rodovia || '');
    }
    if (filterData?.value?.idsMunicipios) {
      filterData?.value?.idsMunicipios.forEach((filter: any) => params = params.append('idsMunicipios', filter));
    }
    if (filtersRange?.anoConclusaoInicio) {
      params = params.set('anoConclusaoInicio', filtersRange?.anoConclusaoInicio || '');
    }
    if (filtersRange?.anoConclusaoFim) {
      params = params.set('anoConclusaoFim', filtersRange?.anoConclusaoFim || '');
    }
    // Campos de data com formatação condicional
    if (filterData?.value?.prazoInicialInicio) {
      params = params.set('prazoInicialInicio', moment(filterData.value.prazoInicialInicio).format('YYYY-MM-DD'));
    }
    if (filterData?.value?.prazoInicialFim) {
      params = params.set('prazoInicialFim', moment(filterData.value.prazoInicialFim).format('YYYY-MM-DD'));
    }
    if (filterData?.value?.prazoFinalInicio) {
      params = params.set('prazoFinalInicio', moment(filterData.value.prazoFinalInicio).format('YYYY-MM-DD'));
    }
    if (filterData?.value?.prazoFinalFim) {
      params = params.set('prazoFinalFim', moment(filterData.value.prazoFinalFim).format('YYYY-MM-DD'));
    }
    if (filterData?.value?.prazoVigenteInicialInicio) {
      params = params.set('prazoVigenteInicialInicio', moment(filterData.value.prazoVigenteInicialInicio).format('YYYY-MM-DD'));
    }
    if (filterData?.value?.prazoVigenteInicialFim) {
      params = params.set('prazoVigenteInicialFim', moment(filterData.value.prazoVigenteInicialFim).format('YYYY-MM-DD'));
    }
    if (filterData?.value?.prazoVigenteFinalInicio) {
      params = params.set('prazoVigenteFinalInicio', moment(filterData.value.prazoVigenteFinalInicio).format('YYYY-MM-DD'));
    }
    if (filterData?.value?.prazoVigenteFinalFim) {
      params = params.set('prazoVigenteFinalFim', moment(filterData.value.prazoVigenteFinalFim).format('YYYY-MM-DD'));
    }

    if (statusFilter && statusFilter !== 'Todos') {
      statusFilter.forEach((status: any) => {
        params = params.append('statusAtuais', status.label);
      });
    }
    if (customFilter) {
      customFilter.forEach((filter: any) => params = params.append('nomesContratos', filter.label));
    }
    return this.http.get(this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao`, { params });
  }

  getAfericaoAmpliacao(idAmpliacao: string) {
    return this.http.get(this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}`);
  }

  postTransicaoStatus(formData: FormData) {
    return this.http.post(this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/processar-status`, formData);
  }

  postTransicaoStatusAnalise(idAmpliacao: string, formData: any) {
    return this.http.post(this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/analises/processar-status`, formData);
  }

  getProtocolos(idAmpliacao: string) {
    return this.http.get(this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/documentos/protocolos`);
  }

  getDocumentosAssinados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idAmpliacao: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '');
    return this.http.get(
      this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/documentos/assinados`, { params }
    );
  }

  getDocumentosComprovacao(
    idAmpliacao: string,
    idDocumentoComprovacao: string,
  ) {
    return this.http.get(
      this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/documentos/${idDocumentoComprovacao}`
    );
  }

  getDocumentosPendentes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idAmpliacao: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '');
    return this.http.get(
      this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/documentos/assinaturas-pendentes`, { params }
    );
  }

  assinarDocumento(idAmpliacao: any, idUsuarioAssinante: any) {
    const data = {
      idUsuarioAssinante: idUsuarioAssinante
    };
    return this.http.post(`${this.baseUrl}/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/documentos/assinar`, data);
  }

  deleteAssinaturaPendente(idAmpliacao: any, idDocumentoComprovacao: any) {
    return this.http.delete(`${this.baseUrl}/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/documentos/${idDocumentoComprovacao}`);
  }

  getDetalhesItemAnalise(idAmpliacao: string, idItemAnalise: string) {
    return this.http.get(
      this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/analises/documentos/${idItemAnalise}`
    );
  }

  getAnaliseAfericoes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idAmpliacao: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '');
    return this.http.get(
      this.baseUrl + `/v1/acompanhamentos/servicos-ampliacao/${idAmpliacao}/analises`, { params }
    );
  }
  getConcessoes(){
    return this.http.get(
      this.baseUrl + `/v1/contracts/parameters?page=0&size=30&sortDirection=asc&sortField=id`
    );
  }
}
